// dependencies
import PropTypes from "prop-types";
import React from "react";

// styles
import css from "./Button.module.scss";

type ButtonProps = {
	children: React.ReactNode;
	href?: string;
};

const Button = ({ children, href }: ButtonProps) => {
	if (href) {
		return (
			<a className={css.buttonMain} href={href}>
				{children}
			</a>
		);
	}

	return <button className={css.buttonMain}>{children}</button>;
};

export default Button;
